import {AppResource, AppResourceCollection} from "@milestoneslabs/milestones-js-engine";
import {store} from "../../index";
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import SearchAlertSubscriberAppResource, {
    NOTIFICATION_FREQUENCY,
    NOTIFICATION_TYPE
} from "@milestoneslabs/milestones-core-js/src/AppResources/SearchAlertSubscriberAppResource";

export default {
    name: 'SavedSearchAlertsMixin',

    mixins: [
        ShowNotificationMixin,
    ],

    data() {
        return {
            isLoading: false,
            currentProjectMemberUuid: store.getters.getWorkspaceOrganizationMemberUuid,
            currentProjectMember: store.getters.getWorkspaceOrganizationMember,
        };
    },

    methods: {
        async subscribeUsers(savedSearchAppResource, appResources) {
            if (
                !Array.isArray(appResources) ||
                !appResources.every(this.checkAppResourceInstance) ||
                !this.checkAppResourceInstance(savedSearchAppResource)
            ) {
                throw new Error('subscribeUsers: Params must be instances of AppResource.');
            }
            this.isLoading = true;

            let subscriberAppResourceCollection = new AppResourceCollection('search-alert-subscriber');
            for (const appResource of appResources) {
                appResource._dirty['enabled'] = appResource.enabled;
                appResource._fetched = false;
                subscriberAppResourceCollection.addResource(appResource);
            }

            savedSearchAppResource.setRelation('searchAlertSubscribers', subscriberAppResourceCollection);

            try {
                await savedSearchAppResource.save(true, false);
                await savedSearchAppResource.load([
                    'searchAlertSubscribers.projectMember.user',
                    'searchAlertSubscribers.projectMember.workspaceMembershipType',
                ]);
            } catch (e) {
                this.showNotification({
                    message: 'Something went wrong. Please try again later',
                    type: 'error'
                });
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        },

        checkAppResourceInstance(item) {
            return item instanceof AppResource;
        },

        updateSubscribers(savedSearchAppResource, newMembers) {
            let subscribers = [];
            if (savedSearchAppResource.searchAlertSubscribers) {
                subscribers = savedSearchAppResource.searchAlertSubscribers.toArray();
            }
            subscribers.forEach(sub => { sub.enabled = false; });

            for (let member of newMembers) {
                let subscriber = subscribers.find(sub => sub.projectMemberUuid === member.uuid);
                if (subscriber) {
                    subscriber.enabled = true;
                } else {
                    subscriber = new SearchAlertSubscriberAppResource({
                        attributes: {
                            propertySearchFilterUuid: savedSearchAppResource.uuid,
                            projectMemberUuid: member.uuid,
                            inviterProjectMemberUuid: this.currentProjectMemberUuid,
                            notificationType: NOTIFICATION_TYPE.EMAIL,
                            notificationFrequencyInMins: NOTIFICATION_FREQUENCY.FOUR_HOURS,
                            enabled: true,
                        }
                    });
                    subscribers.push(subscriber);
                }
            }

            this.subscribeUsers(savedSearchAppResource, subscribers);
        },
    }
};
